
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { actions } from "../../actions/actionsWrapper";
import { eDanhGiaKetQuaActionTypeIds, IDanhGiaKetQuaActions } from "../../action-types/danh-gia/IDanhGiaKetQuaActionType";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { dotDanhGiaKetQuaApi } from "../../../api/danh-gia/dotDanhGiaKetQuaApi";
import { IDanhGiaKetQuaSelectRequest } from "../../../models/request/danh-gia/IDanhGiaKetQuaSelectRequest";
import { IDotDanhGiaKetQuaSubmitRequest } from "../../../models/request/danh-gia/IDotDanhGiaKetQuaSubmitRequest";
import { IDotDanhGiaKetQua } from "../../../models/response/danh-gia/IDotDanhGiaKetQua";

const mainAction = actions.danhGia.danhGiaKetQuaActions;
export function* dotDanhGiaKetQuaSaga(): any {
    yield takeLatest(eDanhGiaKetQuaActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eDanhGiaKetQuaActionTypeIds.SAVE_START, submitWorker)
}

function* loadWorker(action: IDanhGiaKetQuaActions): any {
    const res: IBaseResponeModel = yield call(dotDanhGiaKetQuaApi.Select, action.payload as IDanhGiaKetQuaSelectRequest)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}


function* submitWorker(action: IDanhGiaKetQuaActions): any {
    const res: IBaseResponeModel = yield call(dotDanhGiaKetQuaApi.Submit, action.payload as IDotDanhGiaKetQuaSubmitRequest<IDotDanhGiaKetQua[]>)
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}
